export default __webpack_public_path__ + "static/riley@2x-c40b820b7ceeb2a05428140d3e9e2a71.jpg";